export enum FirmwareField {
    ID = "id",
    HARDWARE_TYPE = "hardwareType",
    TARGET = "target",
    LEGACY = "legacy",
    STATE = "state",
    CHECKSUM = "checksum",
    S3_KEY = "s3Key",
    VERSION_NUMBER = "versionNumber",
    CREATED_AT = "createdAt",
    UPDATED_AT = "updatedAt",
}

export interface Firmware {
    [FirmwareField.ID]: number;
    [FirmwareField.HARDWARE_TYPE]: string;
    [FirmwareField.TARGET]: string;
    [FirmwareField.LEGACY]: boolean;
    [FirmwareField.STATE]: string;
    [FirmwareField.CHECKSUM]: string;
    [FirmwareField.S3_KEY]: string;
    [FirmwareField.VERSION_NUMBER]: string;
    [FirmwareField.CREATED_AT]: string;
    [FirmwareField.UPDATED_AT]: string;
}

export enum FirmwareState {
    DEPRECATED = "DEPRECATED",
    DEVELOPMENT = "DEVELOPMENT",
    ALPHA = "ALPHA",
    BETA = "BETA",
    STABLE = "STABLE",
}
